var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupChatGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3939",
    "data-name": "Group 3939",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.959,
    height: 19.952,
    viewBox: "0 0 19.959 19.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 19.959,
    height: 19.952,
    fill: "#a0a0a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M19.959,8.924v.9c-.011.043-.024.086-.034.13a7.229,7.229,0,0,1-.308,1.28,1.738,1.738,0,0,0-.054,1.322c.157.471.266.958.4,1.438v.078c-.727,0-1.454,0-2.182,0a.65.65,0,0,0-.336.105,5.784,5.784,0,0,1-4.466.947c-.43-.083-.847-.23-1.276-.349-.023.126-.047.273-.075.42A5.794,5.794,0,0,1,2.8,19.023a1.64,1.64,0,0,0-.991-.284c-.6.02-1.193.006-1.805.006.175-.69.353-1.359.514-2.034a.659.659,0,0,0-.031-.386A5.578,5.578,0,0,1,.776,11.2a14.9,14.9,0,0,1,.891-1.271c-.027-.03-.081-.086-.13-.143A5.547,5.547,0,0,1,.37,3.988,1.788,1.788,0,0,0,.415,2.779C.256,2.268.144,1.743.008,1.208c.742,0,1.463,0,2.183-.005A.628.628,0,0,0,2.527,1.1a5.985,5.985,0,0,1,1.928-.9C4.773.114,5.1.064,5.423,0h.936a1.163,1.163,0,0,0,.13.033A5.8,5.8,0,0,1,11.35,3.8c.047.111.086.225.131.345.064-.025.113-.042.159-.064a5.872,5.872,0,0,1,8.086,3.7c.1.372.157.759.233,1.138M1.515,17.576c.358,0,.695.009,1.031,0a.618.618,0,0,1,.439.154,4.624,4.624,0,0,0,2.654,1.049,4.693,4.693,0,0,0,4.873-5.39A4.468,4.468,0,0,0,7.381,9.649,4.5,4.5,0,0,0,2.62,10.712a4.509,4.509,0,0,0-.909,5.445.6.6,0,0,1,.048.48c-.089.3-.16.613-.244.938M18.449,12.9c-.086-.343-.159-.665-.253-.981a.508.508,0,0,1,.045-.406A4.511,4.511,0,0,0,18.7,8.494a4.7,4.7,0,0,0-9.281.392.769.769,0,0,0,.287.779,5.593,5.593,0,0,1,1.955,3.549.38.38,0,0,0,.231.318,4.7,4.7,0,0,0,5.139-.515.605.605,0,0,1,.331-.113c.349-.014.7-.005,1.082-.005M8.259,8.714c.013-.059.025-.109.033-.16A5.767,5.767,0,0,1,10.34,4.9a.2.2,0,0,0,.069-.233,4.757,4.757,0,0,0-4.356-3.5,4.658,4.658,0,0,0-3.1,1.075.549.549,0,0,1-.386.135c-.347-.01-.693,0-1.057,0,.091.356.183.681.25,1.009a.573.573,0,0,1-.036.346,4.671,4.671,0,0,0-.166,3.922A4.417,4.417,0,0,0,2.605,9.208a5.949,5.949,0,0,1,5.653-.494",
    transform: "translate(0 0)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 1.147,
    height: 1.143,
    transform: "translate(2.98 13.496)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 1.145,
    height: 1.146,
    transform: "translate(5.321 13.497)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 1.143,
    height: 1.147,
    transform: "translate(7.658 13.497)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 3.482,
    height: 1.148,
    transform: "translate(12.332 7.647)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 3.483,
    height: 1.145,
    transform: "translate(12.329 9.987)",
    fill: "#a0a0a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupChatGrey);
export default __webpack_public_path__ + "static/media/GroupChatGrey.73a27ae8203dde1110aa927083577a52.svg";
export { ForwardRef as ReactComponent };